import {
  animate,
  keyframes,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';
import { Component } from '@angular/core';

import { Toast, ToastrService, ToastPackage } from 'ngx-toastr';

export interface IToastButton {
  id: any;
}

export const toastrDefaultConfig = {
  closeButton: true,
  timeOut: 10000,
  extendedTimeOut: 5000,
  disableTimeOut: false,
  easing: 'ease-in',
  easeTime: 500,
  enableHtml: true,
  progressBar: true,
  progressAnimation: 'increasing',
  positionClass: 'toast-top-right-custom',
  toastClass: 'ngx-toastr',
  titleClass: 'toast-title',
  messageClass: 'toast-message',
  iconClasses: {
    error: 'toast-error',
    info: 'toast-info',
    success: 'toast-success',
    warning: 'toast-warning',
  },
  tapToDismiss: false,
  onActivateTick: false,
  maxOpened: 4,
  autoDismiss: true,
  newestOnTop: true,
  preventDuplicates: false,
  resetTimeoutOnDuplicate: false,
}

@Component({
    selector: 'app-toastr-custom-action',
    styleUrls: [`./toastr-custom-action.component.scss`],
    templateUrl: `./toastr-custom-action.component.html`,
    // animations: [
    //   trigger('flyInOut', [
    //     state('inactive', style({
    //       opacity: 0,
    //     })),
    //     transition('inactive => active', animate('400ms ease-out', keyframes([
    //       style({
    //         transform: 'translate3d(100%, 0, 0) skewX(-30deg)',
    //         opacity: 0,
    //       }),
    //       style({
    //         transform: 'skewX(20deg)',
    //         opacity: 1,
    //       }),
    //       style({
    //         transform: 'skewX(-5deg)',
    //         opacity: 1,
    //       }),
    //       style({
    //         transform: 'none',
    //         opacity: 1,
    //       }),
    //     ]))),
    //     transition('active => removed', animate('400ms ease-out', keyframes([
    //       style({
    //         opacity: 1,
    //       }),
    //       style({
    //         transform: 'translate3d(100%, 0, 0) skewX(30deg)',
    //         opacity: 0,
    //       }),
    //     ]))),
    //   ]),
    // ],
    preserveWhitespaces: false,
    standalone: false
})
export class ToastrCustomActionComponent extends Toast {
  // constructor is only necessary when not using AoT
  constructor(
    protected toastrService: ToastrService,
    public toastPackage: ToastPackage,
  ) {
    super(toastrService, toastPackage);
  }

  action(btn: IToastButton) {
    // tslint:disable-next-line: deprecation
    event.stopPropagation();
    this.toastPackage.triggerAction(btn);
    this.toastrService.clear();
    return false;
  }
}
